import React, { FC } from 'react';
import { formatters } from '@polymathnetwork/new-shared';

interface TextEllipsisProps {
  size: number;
  children: string;
}

export const TextEllipsis: FC<TextEllipsisProps> = props => {
  const { children, size, ...rest } = props;
  return <span {...rest}>{formatters.toShortAddress(children, { size })}</span>;
};
try {
    // @ts-ignore
    TextEllipsis.displayName = "TextEllipsis";
    // @ts-ignore
    TextEllipsis.__docgenInfo = { "description": "", "displayName": "TextEllipsis", "props": { "size": { "defaultValue": null, "description": "", "name": "size", "required": true, "type": { "name": "number" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/TextEllipsis/TextEllipsis.tsx#TextEllipsis"] = { docgenInfo: TextEllipsis.__docgenInfo, name: "TextEllipsis", path: "src/components/TextEllipsis/TextEllipsis.tsx#TextEllipsis" };
}
catch (__react_docgen_typescript_loader_error) { }